<template>
  <div class="appeals-connect-wrapper">
    <v-card class="pa-6" max-width="520">
      <v-card-title class="justify-center">Подключение организации</v-card-title>
      <v-card-text class="text-center">
        Чтобы просмотреть заявки, необходимо подключить организацию.
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-form @submit.prevent="connect" ref="form">
          <v-btn type="submit" :loading="loading" :disabled="loading" color="primary">
            Подключить
          </v-btn>
        </v-form>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { addOrganization } from '@/api/appeals';

export default {
  name: "AppealsConnect",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ID_ORG() {
      return this.$store.getters['organization/ID_ORG'];
    }
  },
  methods: {
    async connect() {
      if (!this.ID_ORG) {
        this.$store.dispatch('notifications/SHOW_ERROR', 'Организация не выбрана');
        return;
      }
      if (this.loading) return;
      this.loading = true;
      try {
        const { data } = await addOrganization(this.ID_ORG);
        this.$store.dispatch('notifications/SHOW_SUCCESS', (data && data.message) || 'Подключено');
        this.$emit('connected', data && data.model ? data.model : data);
      } catch (err) {
        const message = (err && err.response && err.response.data && err.response.data.message) || 'Ошибка подключения';
        this.$store.dispatch('notifications/SHOW_ERROR', message);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.appeals-connect-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 16px;
}

v-card {
  width: 100%;
}
</style>